import React from 'react'
import { Draggable } from 'react-beautiful-dnd'

import { Item } from './styles'

export default function ({ item, draggableId, ...props }) {
    return (
        <Draggable draggableId={draggableId} {...props}>
            {provided => (
                <Item
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                >
                    <span>{item.descricao}</span>
                </Item>
            )}
        </Draggable>
    )
}
